import styles from "./ServiceSlider.module.css";

const WHATSAPP_NUMBER = "62816744223";
const WHATSAPP_MESSAGE = "Halo Macnesia, saya ingin bertanya";

const SERVICES = [
  "Service Mac Mini",
  "Service Flexgate MacBook",
  "Service MacBook Mati Total",
  "Service iMac Bekasi",
  "Service MacBook Panggilan",
  "Service MacBook Terkena Air",
  "Service MacBook Bekasi",
  "Service MacBook Terdekat",
  "Apple Mac Repairs Near Me",
  "Service MacBook Terbaik",
  "Service iMac Jakarta",
  "Service MacBook Terpercaya",
  "Service MacBook M3",
  "Service MacBook Tangerang",
  "Service MacBook M2",
  "Service iMac",
  "Service MacBook Pro",
  "Service MacBook Jakarta",
  "Service Logic Board MacBook",
  "Service MacBook M1",
  "Service MacBook",
  "Service iMac Terdekat",
  "Service MacBook Depok",
  "Service MacBook M4",
];

const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  WHATSAPP_MESSAGE
)}`;

const ServiceGroup = ({ hidden }: { hidden?: boolean }) => (
  <div className={styles.group} aria-hidden={hidden || undefined}>
    {SERVICES.map((serviceName) => (
      <div className={styles.item} key={serviceName}>
        <a
          className={styles.link}
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          tabIndex={hidden ? -1 : undefined}
          aria-label={`${serviceName} melalui WhatsApp`}
        >
          <span className={styles.name}>{serviceName}</span>
        </a>
      </div>
    ))}
  </div>
);

const ServiceSlider = () => {
  return (
    <section className={styles.slider} aria-label="Daftar layanan Macnesia">
      <div className={styles.viewport}>
        <div className={styles.track}>
          <ServiceGroup />
          <ServiceGroup hidden />
        </div>
      </div>
    </section>
  );
};

export default ServiceSlider;
